import { render, staticRenderFns } from "./farmersModel.vue?vue&type=template&id=301c4124&scoped=true"
import script from "./farmersModel.vue?vue&type=script&lang=js"
export * from "./farmersModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301c4124",
  null
  
)

export default component.exports